import {
	Skeleton,
	ErrorAlert,
	SkeletonProps,
	Stack,
	HStack,
} from '@montel/montelpro-shared-components-v2';
import { FunctionComponent } from 'react';
import { RequestStatus } from 'types/RequestStatus';

interface TableSkeletonProps extends SkeletonProps {
	status: RequestStatus;
	withPagination: boolean;
	withSearch: boolean;
	withFilters: boolean;
}

const TableLoader: FunctionComponent<TableSkeletonProps> = ({
	status,
	children,
	boxSize,
	className,
	speed,
	borderRadius,
	endColor,
	startColor,
	fadeDuration,
	withPagination,
	withFilters,
	withSearch,
}) => {
	if (status === RequestStatus.SUCCESS) return <>{children}</>;

	if (status === RequestStatus.ERROR) {
		return (
			<ErrorAlert
				title="ERROR"
				text="An unexpected error was encountered. Please try again or contact a system administrator."
			/>
		);
	}

	if (status === RequestStatus.FORBIDDEN) {
		return (
			<ErrorAlert
				title="FORBIDDEN"
				text="You do not have access to the requested content."
			/>
		);
	}

	return (
		<Stack gap="md" direction="column" fullWidth>
			<HStack>
				{withSearch && (
					<Skeleton
						borderRadius={borderRadius}
						boxSize={boxSize}
						className={className}
						endColor={endColor}
						fadeDuration={fadeDuration}
						h={'35px'}
						speed={speed}
						startColor={startColor}
						w={'200px'}
					/>
				)}
				{withFilters && (
					<Skeleton
						borderRadius={borderRadius}
						boxSize={boxSize}
						className={className}
						endColor={endColor}
						fadeDuration={fadeDuration}
						h={'35px'}
						speed={speed}
						startColor={startColor}
						w={'500px'}
					/>
				)}
			</HStack>

			<Skeleton
				borderRadius={borderRadius}
				boxSize={boxSize}
				className={className}
				endColor={endColor}
				fadeDuration={fadeDuration}
				h={'350px'}
				speed={speed}
				startColor={startColor}
				w={'100%'}
			/>
			{withPagination && (
				<HStack fullWidth justify="flex-end">
					<Skeleton
						borderRadius={borderRadius}
						boxSize={boxSize}
						className={className}
						endColor={endColor}
						fadeDuration={fadeDuration}
						h={'35px'}
						speed={speed}
						startColor={startColor}
						w={'400px'}
					/>
				</HStack>
			)}
		</Stack>
	);
};

export default TableLoader;
